import { IAppState } from '../../redux';

export function selectMinimalBet(state: IAppState): number {
  return state.auction.minimalBet;
}
